import { createSlice } from "@reduxjs/toolkit";
import { 
  getAppointmentFlow, 
  createAppointmentFlow, 
  updateAppointmentFlow, 
  deleteAppointmentFlow,
  clearLocalActiveAppointmentFlow
} from "./actions";

export const initialState = {
  appointmentFlow: { 
    id: '', 
    email: '', 
    mail_prompt: '', 
    appointment_prompt: '', 
    patient_prompt: '', 
    clinicians_prompt: '', 
    slots_prompt: '',
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'appointmentFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getAppointmentFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppointmentFlow.fulfilled, (state, action) => {
        const { appointment_flow } = action.payload;
        const appointmentFlow = { ...state.appointmentFlow, ...appointment_flow };

        state.loading = false;
        state.appointmentFlow = appointmentFlow;
      })
      .addCase(getAppointmentFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createAppointmentFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAppointmentFlow.fulfilled, (state, action) => {
        const { appointment_flow } = action.payload;

        state.loading = false;
        state.appointmentFlow = appointment_flow;       
      })
      .addCase(createAppointmentFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateAppointmentFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAppointmentFlow.fulfilled, (state, action) => {
        const { status, appointment_flow } = action.payload;
        const updatedAppointmentFlow = { ...state.appointmentFlow, ...appointment_flow };

        state.loading = false;
        if (status === 204) state.appointmentFlow = updatedAppointmentFlow;       
      })
      .addCase(updateAppointmentFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteAppointmentFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAppointmentFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.appointmentFlow = initialState.appointmentFlow;       
      })
      .addCase(deleteAppointmentFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveAppointmentFlow, state => {
        state.appointmentFlow = initialState.appointmentFlow;
      })
  }
})

export default slice.reducer;